<section id="about" >
  <div class="container">


  <header class="section-header">
    <h1 class="section-title" style="text-align: center;">Customer Service Register</h1>
  </header>
  <div class="row row-eq-height justify-content-center">
      <div class="row about-container">

        
          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
           
            <div class="icon-box wow fadeInUp">
              <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Products </a></h4>
              <p class="description">You can create multiple products and maintain there 
                service calls and status.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Customer</a></h4>
              <p class="description">You can add multiple Customers with city name, detailed
                  Address and phone number.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
              <h4 class="title"><a href="">Employees</a></h4>
              <p class="description">You can create an Employee list with Post, Mobile No. & joining date.
                                </p>
            </div>

            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Department</a></h4>
                <p class="description">You can create multiple departments and see details. </p>
              </div>

             
              
                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Warranty AMC Register</a></h4>
                    <p class="description">Warranty & AMC Register,
                                           Product wise Warranty & AMC Register,
                                           Party wise Warranty & AMC Register,
                                           Expired Warranty AMC list.
                      </p>
                  </div>
          </div>
         


          <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Call / Ticket / Problem Register</a></h4>
                  <p class="description">You can raise Ticket and maintain problem / Call register with Party,
                      Customer’s authority person, Priority, City, Product Name, Problem description, Remark,
                      Problem Assigned to, Problem registered by & Office branch.
                    </p>
                </div>
              

            <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Reports</a></h4>
                <p class="description">Product wise problem register,
                    City wise pending and solved problem register,
                    Employee wise pending and solved problem register,
                    Customer wise pending and solved problem register,
                    Priority wise pending and solved problem register,
                    Department wise pending and solved problem register,
                    Group wise pending and solved problem register,
                    On call basis pending and solved problem register,
                    All problems,
                    Pending problems,
                    Engineer’s performance report,
                    Auto Email Delayed problem list to Manager,
                    Error type wise problem detail status,
                    All Other Problems,
                    Pending other problems.
                    
                  </p>
              </div>

              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">City Creation</a></h4>
                  <p class="description">You can create City so can see Citywise Customers and their details.</p>
                </div>     
          </div>
        </div>

        
    </div>
</div>
</section>